import React, { useState } from 'react';
import { Select, Button, Space, Modal, Tooltip } from 'antd';
import { RocketOutlined, InfoCircleOutlined } from '@ant-design/icons';
import './AiClientConnection.less';
import {
  mcpClients,
  handleOpenClient,
  getClientName,
} from '../../utils/mcpClientUtils';
import { McpSetupStep } from '../Walkthrough/steps/McpSetupStep';

const AiClientConnection: React.FC = () => {
  const [selectedClient, setSelectedClient] = useState<string>('claude-ai');
  const [showSetupModal, setShowSetupModal] = useState(false);

  const handleClientChange = (value: string) => {
    setSelectedClient(value);
  };

  const handleSetupInstructions = () => {
    setShowSetupModal(true);
  };

  return (
    <div className="ai-client-connection">
      <div className="section-title">AI Client Connection</div>
      <div className="connection-content">
        <div className="client-selector-row">
          <span className="prompt-text">
            Open your favorite AI Client to use the Cirra AI Admin MCP:
          </span>
          <Space size="middle" align="center">
            <Select
              value={selectedClient}
              onChange={handleClientChange}
              style={{ width: 200 }}
              options={mcpClients}
            />
            <Button
              type="primary"
              icon={<RocketOutlined />}
              onClick={() => handleOpenClient(selectedClient)}
            >
              Open
            </Button>
          </Space>
        </div>

        <div>
          <Space align="center" size={1}>
            <Tooltip title="Get step-by-step instructions for connecting your AI client to Cirra AI">
              <InfoCircleOutlined style={{ fontSize: 14, color: '#8c8c8c' }} />
            </Tooltip>
            <Button
              type="link"
              onClick={handleSetupInstructions}
              className="setup-link-button"
            >
              How to set up Cirra AI in {getClientName(selectedClient)}
            </Button>
          </Space>
        </div>
      </div>

      <Modal
        title="Integrate with your MCP Client"
        open={showSetupModal}
        onCancel={() => setShowSetupModal(false)}
        footer={null}
        width={800}
        styles={{
          body: { maxHeight: 'calc(100vh - 200px)', overflowY: 'auto' },
        }}
        centered={false}
        style={{ top: 20 }}
      >
        <McpSetupStepSimplified
          initialClient={selectedClient}
          onClientSelect={(clientId) => {
            if (clientId !== undefined) {
              setSelectedClient(clientId);
            }
          }}
          isFromSetupLink={true}
        />
      </Modal>
    </div>
  );
};

// Simplified version of McpSetupStep for modal display
const McpSetupStepSimplified: React.FC<{
  initialClient?: string;
  onClientSelect?: (clientId: string | undefined) => void;
  isFromSetupLink?: boolean;
}> = ({ initialClient, onClientSelect, isFromSetupLink }) => {
  return (
    <McpSetupStep
      initialClient={initialClient}
      onClientSelect={onClientSelect}
      hideIntroText={isFromSetupLink}
    />
  );
};

export default AiClientConnection;
